/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef } from "react";
import { Route, Redirect } from "react-router-dom";
import AuthContext from "../../context/Auth/AuthContext";
import NotificacionesContext from "../../context/Notificaciones/NotificacionesContext";
import WindowWarningContext from "../../context/WindowWarning/WindowWarningContext";

export default function RutaPrivada({ component: Component, ...props }) {
  const { autenticado, cargando, usuarioAutenticado } = useContext(AuthContext);

  const { changeEdit } = useContext(WindowWarningContext);

  const { obtenerNumeroNotificaciones } = useContext(NotificacionesContext);

  // Cada minuto va a pedir las notificaciones
  function obtenerNotifRecursivo() {
    obtenerNumeroNotificaciones();
    setTimeout(obtenerNotifRecursivo, 60000); // 60s
  }

  // Hidrata sesión solo si aún es indeterminada
  useEffect(() => {
    if (autenticado === null) {
      usuarioAutenticado();
    }
  }, [autenticado, usuarioAutenticado]);

  // Inicia notificaciones una sola vez cuando ya está autenticado
  const notifStarted = useRef(false);
  useEffect(() => {
    if (autenticado && !notifStarted.current) {
      notifStarted.current = true;
      obtenerNotifRecursivo();
      changeEdit(false);
    }
  }, [autenticado, changeEdit]);

  return (
    <Route
      {...props}
      render={(routeProps) => {
        const hasToken = !!localStorage.getItem("token");

        // Mientras carga o el estado es indeterminado
        if (cargando || autenticado === null) return null;

        // Sin token o explícitamente no autenticado => /login
        if (!hasToken || autenticado === false) {
          return <Redirect to="/login" />;
        }

        // Autenticado
        return <Component {...routeProps} />;
      }}
    />
  );
}
